import { render, staticRenderFns } from "./address-select-dialog.vue?vue&type=template&id=e8858338&scoped=true"
import script from "./address-select-dialog.vue?vue&type=script&lang=js"
export * from "./address-select-dialog.vue?vue&type=script&lang=js"
import style0 from "./address-select-dialog.vue?vue&type=style&index=0&id=e8858338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8858338",
  null
  
)

export default component.exports